/* eslint-disable camelcase */

/** Query params that ask the API for Live Ledger's per-account enrichment source. */
export const LIVE_LEDGER_ENRICHMENT_PARAMS = {
  enrichment_view: "live_ledger",
} as const;

const MX_CATEGORY_KEY_PREFIX = "mx_";
const MX_CATEGORY_KEY = /^mx_(?:[0-9a-f]{2})+$/;
const CATEGORY_KEY = /^[a-z0-9_]+$/;
const MAX_STORED_CATEGORY_LENGTH = 50;

const decodeMxCategoryKey = (key: string): string | null => {
  const hex = key.slice(MX_CATEGORY_KEY_PREFIX.length);
  try {
    // Throws on invalid UTF-8, as the API's decoder does.
    return decodeURIComponent(hex.replace(/../g, "%$&"));
  } catch {
    return null;
  }
};

/** False for a value the API would reject outright, which would break the whole request. */
export const isWellFormedCategoryKey = (key: string): boolean => {
  if (!key.startsWith(MX_CATEGORY_KEY_PREFIX)) return CATEGORY_KEY.test(key);
  if (!MX_CATEGORY_KEY.test(key)) return false;
  const decoded = decodeMxCategoryKey(key);
  // The API counts code points, not UTF-16 units.
  return (
    decoded !== null &&
    !decoded.includes("\0") &&
    Array.from(decoded).length <= MAX_STORED_CATEGORY_LENGTH
  );
};

export const usesMxEnrichment = (
  transaction: Pick<API.Transaction, "enrichment_source">,
): boolean => transaction.enrichment_source === "mx";

/**
 * Whether the viewer may change this row's category and sub-category. Pending rows have no
 * stored transaction to write to, and MX rows are read-only.
 */
export const canCorrectTaxonomy = (
  transaction: Pick<API.Transaction, "enrichment_source" | "settled_at">,
  canWriteTransactions: boolean,
): boolean =>
  canWriteTransactions &&
  Boolean(transaction.settled_at) &&
  !usesMxEnrichment(transaction);
